import { render, staticRenderFns } from "./addDiolag.vue?vue&type=template&id=26dfa6d6&scoped=true"
import script from "./addDiolag.vue?vue&type=script&lang=js"
export * from "./addDiolag.vue?vue&type=script&lang=js"
import style0 from "./addDiolag.vue?vue&type=style&index=0&id=26dfa6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dfa6d6",
  null
  
)

export default component.exports